import { render, staticRenderFns } from "./ShipbluButton.vue?vue&type=template&id=2c04f656"
import script from "./ShipbluButton.vue?vue&type=script&lang=js"
export * from "./ShipbluButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports